module.exports = __webpack_public_path__ + "static/media/silhouette_A4.2f12400a.png";